import { InterviewKitTemplateService } from '../../../services/v1/applicant_tracking/InterviewKitTemplateService';
import { randomInt } from '../../../utils/number';
import {
  FieldConfig,
  FieldData,
  ColumnConfig,
} from '../../survey_engine/SurveyTemplates/Field';
import { SectionData } from '../../survey_engine/SurveyTemplates/Section';

export {
  areSectionsSavable,
  getFieldError,
} from '../../survey_engine/SurveyTemplates/utils';

export const COLUMNS: ColumnConfig[] = [
  {
    fieldName: 'text',
    className: 'col',
    label: 'Questions',
    helperText: 'Maximum 255 characters',
    placeholder: 'Insert Question',
    maxLength: 255,
  },
];

export const FIELD_CONFIGS: FieldConfig[] = [
  {
    label: 'Open Text Response',
    fieldType: 'text',
  },
];

export async function fetchTemplate(id: string) {
  const template = await InterviewKitTemplateService.show(id, {
    expand: [
      'survey_template',
      'survey_template.sections',
      'survey_template.sections.questions',
    ],
  });

  const cSections: SectionData[] = [];
  for (const sSection of template.surveyTemplate.sections) {
    const cFields: FieldData[] = [];
    for (const sField of sSection.questions) {
      cFields.push({
        serverId: sField.id,
        clientId: randomInt(),
        title: sField.title,
        label: 'Open Text Response',
        fieldType: 'text',
        aiFillEnabled: sField.aiFillEnabled,
      });
    }

    cSections.push({
      sId: sSection.id,
      cId: randomInt(),
      name: sSection.name,
      fields: cFields,
    });
  }

  return {
    name: template.surveyTemplate.name,
    sections: cSections,
    default: template.default,
  };
}
